export function deleteMutationResponseTransformer() {
  return {
    success: true
  }
}
